export default __webpack_public_path__ + "static/media/4.35e09188.jpg";